const GETSECURITYINFO = "GETSECURITYINFO";
const GETSECURITYINFO_SUCCESS = "GETSECURITYINFO_SUCCESS";
const GETSECURITYINFO_FAIL = "GETSECURITYINFO_FAIL";
const DOWNLOADEXCEL = "DOWNLOADEXCEL";
const DOWNLOADEXCEL_SUCCESS = "DOWNLOADEXCEL_SUCCESS";
const DOWNLOADEXCEL_FAIL = "DOWNLOADEXCEL_FAIL";

export default function security(
  state = {
    dataSecurity: [],
    isLoading: true,
    hasError: false,
  },
  action,
) {
  switch (action.type) {
    case GETSECURITYINFO: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case GETSECURITYINFO_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        hasError: false,
        dataSecurity: action.payload.data,
      };
    }

    case GETSECURITYINFO_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    }

    case DOWNLOADEXCEL: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DOWNLOADEXCEL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case DOWNLOADEXCEL_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    }
    default:
      return state;
  }
}

export const getSecurityInfo = () => {
  return {
    type: GETSECURITYINFO,
    payload: {
      request: {
        url: "Security",
      },
    },
  };
};

export const downloadInfo = (data) => {
  return {
    type: DOWNLOADEXCEL,
    payload: {
      request: {
        url: "Security/Download",
        method: "POST",
        data: data,
        responseType: "blob",
      },
    },
  };
};
